// extracted by mini-css-extract-plugin
export var layoutContainer = "_54-0";
export var layoutContainerNoRounding = "_54-6";
export var layoutContainerOpen = "_54-5";
export var layoutContainerResizing = "_54-1";
export var mainContent = "_54-2";
export var resizeDivider = "_54-3";
export var slidePanel = "_54-4";